export const shouldAllowContentPreview = (): boolean => process.env.ENVIRONMENT !== 'prd';
